import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en.js'
import pt from './pt.js'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'pt',
  fallbackLocale: 'en',
  messages: { en: en, pt: pt }
})

export default i18n